import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc312ef6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"10px"} }
const _hoisted_2 = { style: {"position":"relative","height":"100%"} }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "children" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sc_btn = _resolveComponent("sc-btn")!
  const _component_sc_drop = _resolveComponent("sc-drop")!
  const _component_sc_tree_node = _resolveComponent("sc-tree-node")!
  const _component_sc_drag = _resolveComponent("sc-drag")!
  const _component_tran_reduce = _resolveComponent("tran-reduce")!
  const _component_sc_tree = _resolveComponent("sc-tree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_sc_btn, {
      text: "打开全部",
      handler: () => _ctx.$refs.tree.setOpenedAll(true)
    }, null, 8, ["handler"]),
    _createVNode(_component_sc_btn, {
      text: "关闭全部",
      handler: () => _ctx.$refs.tree.setOpenedAll(false)
    }, null, 8, ["handler"]),
    _createVNode(_component_sc_btn, {
      text: "打开所在",
      handler: () => _ctx.$refs.tree.openNode(_ctx.$refs.tree.getSelectedNode().id)
    }, null, 8, ["handler"]),
    _createVNode(_component_sc_tree, { ref: "tree" }, {
      default: _withCtx(({ node, children }) => [
        _createVNode(_component_sc_drag, {
          format: "node",
          data: node.id,
          img: { el: _ctx.dragImg[node.id] }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_sc_tree_node, {
              node: node,
              menus: _ctx.getMenus(node)
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_sc_drop, {
                    accept: "node",
                    onDrop: ($event: any) => (_ctx.onDrag($event, node, 'before'))
                  }, {
                    default: _withCtx(({ hover, dragging }) => [
                      _withDirectives(_createElementVNode("div", {
                        style: _normalizeStyle([{"position":"absolute","height":"50%","width":"100%","z-index":"10"}, { borderTop: hover ? '1px solid red' : '' }])
                      }, null, 4), [
                        [_vShow, dragging]
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onDrop"]),
                  _createVNode(_component_sc_drop, {
                    accept: "node",
                    onDrop: ($event: any) => (_ctx.onDrag($event, node, 'inside'))
                  }, {
                    default: _withCtx(({ hover, dragging }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass(["title", { hover, dragging }]),
                        ref: (el) => (_ctx.dragImg[node.id] = el)
                      }, [
                        _createTextVNode(_toDisplayString(node.id) + " " + _toDisplayString(node.data.title) + " ", 1),
                        _createElementVNode("span", {
                          onClick: ($event: any) => (_ctx.add(node))
                        }, "添加", 8, _hoisted_3)
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["onDrop"])
                ])
              ]),
              _: 2
            }, 1032, ["node", "menus"])
          ]),
          _: 2
        }, 1032, ["data", "img"]),
        _createVNode(_component_tran_reduce, {
          show: node.opened
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(children, (child, index) => {
                return (_openBlock(), _createBlock(_resolveDynamicComponent(child), { key: index }))
              }), 128))
            ])
          ]),
          _: 2
        }, 1032, ["show"])
      ]),
      _: 1
    }, 512)
  ]))
}